import clsx from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { HeadLine } from 'atoms/Typography/Typography';
import styles from './ProductGridLayout.module.css';

export const ProductGridContainer: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};

export const ProductGridTitle: FC<
  PropsWithChildren<{
    className?: string;
    color?: 'black' | 'purple' | 'white';
  }>
> = ({ children, className, color }) => {
  return (
    <HeadLine type="m" color={color} className={clsx(styles.title, className)}>
      {children}
    </HeadLine>
  );
};
